"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGE_UPDATED = exports.PAGE_RENAMED = exports.PAGE_DELETE_MODAL_OPENED = exports.PAGE_DELETE_MODAL_CLOSED = exports.PAGE_DELETED = exports.PAGE_CREATED = exports.MEDIA_SELECTED = exports.DRAFT_PUBLISHED = void 0;
var PAGE_CREATED = exports.PAGE_CREATED = 'Page created';
var PAGE_RENAMED = exports.PAGE_RENAMED = 'Page renamed';
var PAGE_DELETED = exports.PAGE_DELETED = 'Page deleted';
var PAGE_UPDATED = exports.PAGE_UPDATED = 'Page updated';
var PAGE_DELETE_MODAL_OPENED = exports.PAGE_DELETE_MODAL_OPENED = 'Page delete modal opened';
var PAGE_DELETE_MODAL_CLOSED = exports.PAGE_DELETE_MODAL_CLOSED = 'Page delete modal closed';
var DRAFT_PUBLISHED = exports.DRAFT_PUBLISHED = 'Draft published';
var MEDIA_SELECTED = exports.MEDIA_SELECTED = 'Media selected';
//# sourceMappingURL=events.js.map